import React from "react";
import MDEditor, { commands } from "@uiw/react-md-editor";

interface RichTextInputProps {
  containerClassName?: string;
  dataColorMode?: "light" | "dark" | string;
  label?: React.ReactNode;
  value?: string;
  onChange?: (val?: string) => void;
}

const RichTextInput: React.FC<RichTextInputProps> = ({
  containerClassName,
  dataColorMode,
  label,
  value,
  onChange,
}) => {
  return (
    <div className={containerClassName} data-color-mode={dataColorMode}>
      {label && <label className="text-sm font-medium">{label}</label>}
      <MDEditor
        value={value}
        onChange={onChange}
        preview={"live"}
        commands={[
          commands.heading1,
          commands.heading2,
          commands.heading3,
          commands.divider,
          commands.bold,
          commands.italic,
          commands.strikethrough,
          commands.divider,
          commands.link,
          commands.orderedListCommand,
          commands.unorderedListCommand,
          commands.divider,
        ]}
      />
    </div>
  );
};

export default RichTextInput;
